import React from "react";
import { Button, Container } from "@mui/material";
import { NameClaim } from "../../models/authentication";
import { useAuth } from "../../shared/provider/auth_provider";

const UnauthorizedComponent = () => {
  const { authData, signOut } = useAuth();

  let showAccountInfo = false;
  let accountInfoBox = <></>;

  if (authData != null) {
    showAccountInfo = true;
    const humanName = authData.claims.find((cla) => cla.type == NameClaim);

    accountInfoBox = (
      <div>
        <ul>
          <li>User: {humanName ? humanName.value : ""}</li>
          <li>UserName: {authData.name}</li>
        </ul>
      </div>
    );
  }

  return (
    <div>
      <Container>
        <h1>Kein Zugriff</h1>
        <p>
          Sie besitzen nicht die notwendigen Rechte, um auf diese Seite
          zuzugreifen
        </p>

        {showAccountInfo ? (
          <>
            <Button variant="outlined" onClick={() => signOut()}>
              Abmelden und mit anderem Konto anmelden
            </Button>
            <h2>Account:</h2>
            {accountInfoBox}
          </>
        ) : (
          <></>
        )}
      </Container>
    </div>
  );
};

export default UnauthorizedComponent;
